export default __webpack_public_path__ + "static/media/page-title-badge-light.84eccf23.svg";